<template>
  <main-layout>
    <div
      class="relative pt-16 pb-20 px-4 sm:px-8 lg:pt-24 lg:pb-28 lg:px-12 min-h-screen"
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative max-w-7xl mx-auto">
        <div class="text-center">
          <h2
            class="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10"
          >
            Post a job
          </h2>
          <p
            class="my-4 mb-6 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4"
          >
            Please fill in the form to post a job on RemoteRocket for just $90
          </p>
          <div class="flex items-center justify-center">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSdqlLgAhuv3AAAIKKiGc2Vx0ooSKekmeY4TZfq31SYt2HnO-Q/viewform?embedded=true"
              width="640"
              height="1803"
              frameborder="0"
              marginheight="0"
              marginwidth="0"
              >Loading...</iframe
            >
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue';

export default {
  name: 'JobList',
  components: {
    MainLayout,
  },
};
</script>
